import Image from '@atlaskit/image';
import tooltipAnatomyLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-anatomy-light.png";
import tooltipAnatomyDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-anatomy-dark.png";
import tooltipButtonDoLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-button-do-light.png";
import tooltipButtonDoDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-button-do-dark.png";
import tooltipButtonDontLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-button-dont-light.png";
import tooltipButtonDontDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-button-dont-dark.png";
import tooltipInfoDoLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-info-do-light.png";
import tooltipInfoDoDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-info-do-dark.png";
import tooltipInfoDontLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-info-dont-light.png";
import tooltipInfoDontDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-info-dont-dark.png";
import tooltipTruncationDoLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-truncation-do-light.png";
import tooltipTruncationDoDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-truncation-do-dark.png";
import tooltipTruncationDontLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-truncation-dont-light.png";
import tooltipTruncationDontDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-truncation-dont-dark.png";
import tooltipInteractive1DoLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-interactive-1-do-light.png";
import tooltipInteractive1DoDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-interactive-1-do-dark.png";
import tooltipInteractive1DontLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-interactive-1-dont-light.png";
import tooltipInteractive1DontDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-interactive-1-dont-dark.png";
import tooltipInteractive2DoLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-interactive-2-do-light.png";
import tooltipInteractive2DoDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-interactive-2-do-dark.png";
import tooltipInteractive2DontLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-interactive-2-dont-light.png";
import tooltipInteractive2DontDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-interactive-2-dont-dark.png";
import tooltipCriticalDoLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-critical-do-light.png";
import tooltipCriticalDoDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-critical-do-dark.png";
import tooltipCriticalDontLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-critical-dont-light.png";
import tooltipCriticalDontDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-critical-dont-dark.png";
import tooltipContentsDoLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-contents-do-light.png";
import tooltipContentsDoDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-contents-do-dark.png";
import tooltipContentsDontLight from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-contents-dont-light.png";
import tooltipContentsDontDark from "../../../../../../packages/design-system/tooltip/constellation/index/images/tooltip-contents-dont-dark.png";
import * as React from 'react';
export default {
  Image,
  tooltipAnatomyLight,
  tooltipAnatomyDark,
  tooltipButtonDoLight,
  tooltipButtonDoDark,
  tooltipButtonDontLight,
  tooltipButtonDontDark,
  tooltipInfoDoLight,
  tooltipInfoDoDark,
  tooltipInfoDontLight,
  tooltipInfoDontDark,
  tooltipTruncationDoLight,
  tooltipTruncationDoDark,
  tooltipTruncationDontLight,
  tooltipTruncationDontDark,
  tooltipInteractive1DoLight,
  tooltipInteractive1DoDark,
  tooltipInteractive1DontLight,
  tooltipInteractive1DontDark,
  tooltipInteractive2DoLight,
  tooltipInteractive2DoDark,
  tooltipInteractive2DontLight,
  tooltipInteractive2DontDark,
  tooltipCriticalDoLight,
  tooltipCriticalDoDark,
  tooltipCriticalDontLight,
  tooltipCriticalDontDark,
  tooltipContentsDoLight,
  tooltipContentsDoDark,
  tooltipContentsDontLight,
  tooltipContentsDontDark,
  React
};